import { render, staticRenderFns } from "./ListNormal.vue?vue&type=template&id=6cab8bab&"
import script from "./ListNormal.vue?vue&type=script&lang=js&"
export * from "./ListNormal.vue?vue&type=script&lang=js&"
import style0 from "./ListNormal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports